import { render, staticRenderFns } from "./ActivationPopupAlert.vue?vue&type=template&id=f5919ab2&"
import script from "./ActivationPopupAlert.vue?vue&type=script&lang=js&"
export * from "./ActivationPopupAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports